import React, { useContext } from "react";
import clsx from "clsx";
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import WebProfileContext from "@WebProfileContext";

import styles from "./Map.styles";

const Map = () => {
	const [profileData] = useContext(WebProfileContext);
	const theme = useTheme();
	const screenMD = useMediaQuery(theme.breakpoints.up("md"));
	const css = styles();

	const link = profileData?.customLinks?.find(item => item?.identifier === "google-maps")?.url;

	return (
		<div className={clsx(css.map, "mco-view-component-footer-map")}>
			<a href={link} target="_blank" rel="noreferrer">
				<img
					src="/img/map.svg"
					alt="Map"
					height={screenMD ? 272 : 212}
					width={screenMD ? 531 : 414}
					loading="lazy"
				/>
			</a>
		</div>
	);
};

export default Map;
